import {mixins} from "../app/mixin";

mixins.push({
    el: '#lca',
    data() {
        return {
            selectedWhyImportantCard: 1,
            selectedSkill: 1,
        }
    },
    methods: {
        selectCard(card) {
            this.selectedWhyImportantCard = card;
        },
        selectSkill(skill) {
            this.selectedSkill = skill;
        },
    },
});